// extracted by mini-css-extract-plugin
export var btnSecondary = "styles-module--btn-secondary--1979f";
export var controls = "styles-module--controls--8e5b6";
export var fadeIn = "styles-module--fadeIn--bfe04";
export var img1 = "styles-module--img1--33e50";
export var img2 = "styles-module--img2--b5dd6";
export var isActive = "styles-module--isActive--7d706";
export var isBlurred = "styles-module--isBlurred--c3eb5";
export var isHidden = "styles-module--isHidden--88b5a";
export var isVisible = "styles-module--isVisible--26f5e";
export var loadingBg = "styles-module--loadingBg--78d72";
export var loadingBg_animation = "styles-module--loadingBg_animation--513fe";
export var productCard = "styles-module--productCard--4d4c5";
export var productCardCta = "styles-module--productCardCta--cfd79";
export var productCardDownloadsButton = "styles-module--productCardDownloadsButton--515e8";
export var productCardDownloadsIcon = "styles-module--productCardDownloadsIcon--a9670";
export var productCardDownloadsItem = "styles-module--productCardDownloadsItem--835e9";
export var productCardDownloadsMenu = "styles-module--productCardDownloadsMenu--d6f7c";
export var productCardImageWrapper = "styles-module--productCardImageWrapper--6e62a";
export var productCardLink = "styles-module--productCardLink--8e9fc";
export var productCardLinkAddCart = "styles-module--productCardLinkAddCart--84764";
export var productCardLinkCode = "styles-module--productCardLinkCode--eaf6b";
export var productCardLinkFinish = "styles-module--productCardLinkFinish--ca0a5";
export var productCardUpper = "styles-module--productCardUpper--8d167";
export var productCardUpperImagesContainer = "styles-module--productCardUpperImagesContainer--9fb28";
export var productCardUpperSmall = "styles-module--productCardUpperSmall--8bc69";
export var willHide = "styles-module--willHide--0e92f";